import { RootState, store } from 'app/store';
import { selectBrandCode } from 'services/brand/brandSelectors';
import type { IBrandConfig } from './types';
import BRAND_CONFIG from './brand-config';

type BrandConfigKeyType = keyof IBrandConfig;

function getFromBrandConfig<K extends BrandConfigKeyType>(
  key: K,
): IBrandConfig[K] {
  const appStore = store.getState() as RootState;
  const brandCode = selectBrandCode(appStore);
  const brandConfig = BRAND_CONFIG[brandCode] ?? BRAND_CONFIG.default;

  // fall back to default's value for this key if brand doesn't define it
  return brandConfig[key] ?? BRAND_CONFIG.default[key];
}

export default getFromBrandConfig;
